<div class="card border rounded border-dark shadow-lg">
  <div class="card-body">
    <img *ngIf="user?.photoURL" class="float-right img-fluid p-1 text-right" [src]="user.photoURL">
    <h5 class="card-title">{{user?.displayName}}</h5>
    <p class="card-text"><abbr title="Email">E:</abbr> {{user.email}}</p>
  </div>
</div>